import { base, reset, TmElement } from '@thiememeulenhoff/lit-sdk';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../helpers';
import { borderBlockStyles } from './border-block.styles';

const tag = tagName('border-block');

type BlockTypes = 'info' | 'success' | 'error' | 'filter';
type SizeTypes = 'tiny' | 'small' | 'large';

@customElement(tag)
export class BorderBlockComponent extends TmElement {
  @property({ type: String, reflect: true })
  type: BlockTypes = 'info';

  @property({ type: Boolean, reflect: true })
  closeable = false;

  @property({ type: Boolean, reflect: true })
  disabled?: boolean;

  @property({ type: String, reflect: true })
  size: SizeTypes = 'large';

  static override styles = [base.focus, reset.button, borderBlockStyles];

  protected closeButton() {
    if (this.closeable) {
      return html`<button @click=${this.close} data-test="close-button" aria-label="Sluiten">
          <a-icon
            name="close"
            class="close"
          >
        </button>`;
    }
    return nothing;
  }

  close() {
    this.remove();
    this.dispatchLocalEvent({
      eventName: 'close',
    });
  }

  override render() {
    return html`<div class="main">
        <div class="title">
          <slot name="title" data-test="title-slot"></slot>
        </div>
        <slot data-test="slot"></slot>
      </div>
      ${this.closeButton()} `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-border-block': BorderBlockComponent;
  }
}
